/* @ngInject */
export default function controller() {
  const ctrl = this

  ctrl.$onInit = () => {}
}
